import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

import { FundAssetsControl } from '@/components/FundAssetsControl'
import { FundCompositionChart } from '@/components/FundCompositionChart'

export const Route = createFileRoute('/_app/fund/$id/assets')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()

  return (
    <Stack>
      <FundAssetsControl fundId={id} />
      <FundCompositionChart fundId={id} />
    </Stack>
  )
}
